var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEngineeringinline = function SvgEngineeringinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 45"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "#576CDB",
    rx: 5.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2.25,
    d: "m25.462 10.748 1.633-1.493a.91.91 0 0 1 1.13-.107l2.042 1.281c.366.23.553.664.479 1.118l-.373 2.287c-.346 2.119 1.104 4.849 2.965 5.582l2.007.793c.398.157.651.55.651 1.01v2.562c0 .46-.253.854-.651 1.01l-2.005.792c-1.86.733-3.313 3.47-2.966 5.587l.372 2.282c.075.454-.112.888-.48 1.119l-2.04 1.281a.91.91 0 0 1-1.131-.107l-1.632-1.493c-1.515-1.385-4.419-1.385-5.932 0l-1.633 1.492a.91.91 0 0 1-1.13.108l-2.042-1.28c-.367-.23-.553-.666-.48-1.12l.374-2.286c.345-2.118-1.104-4.848-2.965-5.583l-2.008-.792c-.398-.157-.65-.55-.65-1.01V21.22c0-.46.253-.854.65-1.01l2.005-.792c1.86-.733 3.313-3.47 2.967-5.587l-.373-2.282c-.074-.454.112-.889.48-1.119l2.041-1.281a.91.91 0 0 1 1.13.108l1.632 1.492c1.515 1.385 4.419 1.385 5.933 0Z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.496,
    cy: 22.5,
    r: 3.75,
    fill: "#fff"
  })));
};
export default SvgEngineeringinline;